// extracted by mini-css-extract-plugin
module.exports = {"patient-info__img-preview":"style_patient-info__img-preview__2FXRH"};